var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSocialUnauthLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 16.6836C24.9587 16.6836 26.3576 17.2364 27.3891 18.2204C28.4205 19.2044 29 20.539 29 21.9306V28.052H25.3333V21.9306C25.3333 21.4667 25.1402 21.0218 24.7964 20.6938C24.4525 20.3658 23.9862 20.1816 23.5 20.1816C23.0138 20.1816 22.5475 20.3658 22.2036 20.6938C21.8598 21.0218 21.6667 21.4667 21.6667 21.9306V28.052H18V21.9306C18 20.539 18.5795 19.2044 19.6109 18.2204C20.6424 17.2364 22.0413 16.6836 23.5 16.6836V16.6836Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 17.6309H11V28.0519H15V17.6309Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 15.7367C14.1046 15.7367 15 14.8884 15 13.842C15 12.7956 14.1046 11.9473 13 11.9473C11.8954 11.9473 11 12.7956 11 13.842C11 14.8884 11.8954 15.7367 13 15.7367Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSocialUnauthLinkedin);
export default __webpack_public_path__ + "static/media/icon_social_unauth_linkedin.d4136df551f8b776fcc6c38d006fcce5.svg";
export { ForwardRef as ReactComponent };